import { createContext, useContext, useState } from 'react';

type RightHandSidebarContextProps = {
  isOpen: boolean;
  openSidebar: (
    data: JSX.Element,
    title?: string | JSX.Element,
    width?: string,
  ) => void;
  closeSidebar: () => void;
  title: string | JSX.Element | null;
  content: JSX.Element | null;
  sidebarWidth: string;
};

const RightHandSidebarContext = createContext<RightHandSidebarContextProps>(
  {} as RightHandSidebarContextProps,
);

type RightHandSidebarProviderProps = {
  children: JSX.Element;
};

export function RightHandSidebarProvider({
  children,
}: RightHandSidebarProviderProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [content, setContent] = useState<JSX.Element | null>(null);
  const [title, setTitle] = useState<string | JSX.Element | null>(null);
  const [sidebarWidth, setSidebarWidth] = useState<string>('340px');

  const openSidebar = (
    data: JSX.Element,
    title: string | JSX.Element = '',
    width: string = '340px',
  ) => {
    setContent(data);
    setIsOpen(true);
    setTitle(title);
    setSidebarWidth(width);
  };

  const closeSidebar = () => {
    setIsOpen(false);
    setContent(null);
  };

  return (
    <RightHandSidebarContext.Provider
      value={{
        isOpen,
        openSidebar,
        closeSidebar,
        title,
        content,
        sidebarWidth,
      }}
    >
      {children}
    </RightHandSidebarContext.Provider>
  );
}

export function useRightHandSidebar() {
  return useContext(RightHandSidebarContext);
}
